import React from 'react';
import { SectionHeading } from './SectionHeading';
import { RichText } from './RichText';
import { brandName, packContents } from '../../data/landing';
export function PackContents() {
  return <section aria-labelledby="contents-title" className="bg-cream py-16 md:py-24" data-id="element-183" data-mp="580dffhsiscy">
      <div className="mx-auto max-w-6xl px-5" data-id="element-184" data-mp="a6k23nnrqi90">
        <SectionHeading id="contents-title" title={<>
              ¿Qué contiene <RichText text={brandName} data-id="element-186" data-mp="3rlifz5hxdh0n" />?
            </>} data-id="element-185" data-mp="a58z3q25deiy" />
        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-187" data-mp="9fls4glth04">
          {packContents.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex flex-col items-center rounded-3xl border border-line bg-paper px-6 py-9 text-center" data-id="element-188" data-mp="3ikagwl7l4c5i">
              <Icon className="h-8 w-8 text-primary" strokeWidth={1.75} aria-hidden="true" data-id="element-189" data-mp="38pigzaqj5d7k" />
              <h3 className="mt-4 font-serif text-2xl leading-tight text-ink" data-id="element-190" data-mp="3dm90k81jmqxq">
                <RichText text={title} data-id="element-191" data-mp="19zwg99d5xzno" />
              </h3>
              {text && <p className="mt-2 text-[15px] text-muted" data-id="element-192" data-mp="151uv8iw6fq9k">
                  <RichText text={text} data-id="element-193" data-mp="151bbcwmyursw" />
                </p>}
            </li>)}
        </ul>
      </div>
    </section>;
}